<template>
  <div class="descriptionOfGoods">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.ReportsDetail.BULK_SUMMARY') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Packed') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.packed"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfGoods.packed"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Unpacked') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.unpacked"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfGoods.unpacked"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Semi_finished') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.semi"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfGoods.semi"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Sambox') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.sampboxphoto"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfGoods.semi"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.ReportsDetail.Samproduct') }}</span>
      <div class="img">
        <show-img
          :data="descriptionOfGoods.sampproductphoto"
          :otherData="{
            mediaName: '',
            mediaType: '',
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: '',
          }"
          :id="id"
        ></show-img>
        <!-- <img
          v-for="item in descriptionOfGoods.semi"
          :key="item.id"
          :src="config.baseUrlImg + item.mediaPath"
        /> -->
      </div>
    </div>
    <div class="desOfGoods-table">
      <a-table
        class="desOfGoods-table1"
        :columns="columns"
        :dataSource="data"
        bordered
        :pagination="false"
        rowKey="id"
      >
        <template slot="footer">
          <p class="footer1">
            <span>{{ $tc('lang.ReportsDetail.Remarks') }}</span>
            <span v-if="data == undefined"></span>
            <span v-else-if="data.length == 0"></span>
            <span v-else>{{ data[0].goodsRemark }}</span>
          </p>
          <!-- <p>
            <span>内容说明：</span>
            <span>123</span>
          </p> -->
        </template>
      </a-table>
    </div>
  </div>
</template>
<script>
import showImg from './showImg';
export default {
  data() {
    return {
      columns: [
        {
          title: this.$tc('lang.ReportsDetail.Descriptions'),
          children: [
            {
              title: this.$tc('lang.ReportsDetail.P_O_Number'),
              dataIndex: 'ireportId',
              key: 'ireportId',
            },
            {
              title: this.$tc('lang.ReportsDetail.Product_name'),
              dataIndex: 'goodsName',
              key: 'goodsName',
            },
          ],
        },
        {
          title: this.$tc('lang.ReportsDetail.Completed_quantity'),
          children: [
            {
              title: this.$tc('lang.ReportsDetail.packed'),
              dataIndex: 'goodsPacked',
              key: 'goodsPacked',
            },
            {
              title: this.$tc('lang.ReportsDetail.unpacked'),
              dataIndex: 'goodsUnpackcount',
              key: 'goodsUnpackcount',
            },
            {
              title: this.$tc('lang.ReportsDetail.Total_Carton'),
              dataIndex: 'goodsPackcount',
              key: 'goodsPackcount',
            },
          ],
        },
        {
          title: this.$tc('lang.ReportsDetail.Unfinished'),
          children: [
            {
              title: this.$tc('lang.ReportsDetail.Semi_finished_Quantity'),
              dataIndex: 'goodsSemicount',
              key: 'goodsSemicount',
            },
          ],
        },
        {
          title: this.$tc('lang.ReportsDetail.ActualShipmentQuantity'),
          dataIndex: 'goodsActualcount',
          key: 'goodsActualcount',
        },
      ],
      data: [],
    };
  },
  components: {
    showImg,
  },
  computed: {
    details: {
      get() {
        return JSON.parse(JSON.stringify(this.$store.state.report.details));
      },
    },
    descriptionOfGoods: {
      get() {
        return this.$store.state.report.imgList.descriptionOfGoods;
      },
    },
  },
  created() {
    console.log(this.details);
    this.getSelectDate();
  },
  methods: {
    getSelectDate() {
      this.$http
        .post('/hzwmj/inspect-goods/selectDate', {
          orderNo: this.details.orderId,
          reportNo: this.details.ireportId,
        })
        .then(data => {
          if (data.data) {
            this.data = [data.data];
          } else {
            this.data = [];
          }
        })
        .catch(() => {
          this.data = [];
        });
    },
  },
};
</script>
<style lang="less">
.descriptionOfGoods {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    // .img {
    //   flex-grow: 1;
    // }
    > span {
      display: inline-block;
      /*width: 100px;*/
      flex-shrink: 0;
      padding-left: 20px;
      text-align: left;
      width: 120px;
      // text-align: center;
    }
    // img {
    //   width: 20%;
    //   height: 150px;
    //   margin: 0 20px 20px;
    // }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table1 {
      flex-grow: 1;
      margin-left: 20px;
      .ant-table-footer {
        padding: 0;
        .footer1 {
          // border-right: 1px solid #e8e8e8;
          width: 30%;
        }
        p {
          display: inline-block;
          padding: 0 16px;
          margin-bottom: 0;
          line-height: 52px;
        }
      }
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
</style>
